export const PRICING_FEATURE_BULLETS = [
  'Slack and email alerts',
  'Define escalation policies',
  'SSL & domain expiry monitoring',
  'GET and POST request support',
  'Browser-like user agents',
  'Custom request headers',
] as const

export const PRICING_FEATURE_FOOTNOTE =
  'Built for strict filters—Cloudflare and similar—when you need realistic checks.'
